import React from 'react';
import useTranslatedText from '../../../hooks/useTranslatedText';
import smallScreenNavDataV2Shape from '../propTypesShapes';
import Menu from './Menu';
import MenuBack from './MenuBackButton';
import TopLevelMenu from './TopLevelMenu';

const MenuDataWrapper = ({
  data = {},
}) => {
  const allLabel = useTranslatedText('all', { fallback: 'All' });

  const footerLogos = data?.footer?.footerLogos || [];

  return (
    <>
      {/* The back button */}
      <MenuBack handleClick={() => {}} label={allLabel.value} />
      {/* L0 level menu only with L1 categories and footer */}
      <TopLevelMenu
        footerLinks={[
          {
            label: 'Help',
            id: 'help',
          },
          {
            label: 'Privacy & Terms',
            id: 'privacy',
          },
          {
            label: 'About Us',
            id: 'about-us',
          },
          {
            label: 'Contact Us',
            id: 'contact-us',
          },
        ]}
        footerLogos={footerLogos}
        handleClick={(id) => console.log(id)}
        primaryLinks={[
          {
            label: 'New',
            id: '613723369',
            hasSpecialNavInteraction: false,
            espotIdentifier: '613660550-ANF',
          },
          {
            label: 'Women\'s',
            id: '12203',
            hasSpecialNavInteraction: false,
            espotIdentifier: '12266-ANF',
          },
          {
            label: 'Men\'s',
            id: '12202',
            hasSpecialNavInteraction: false,
            espotIdentifier: '12202-ANF',
          },
          {
            label: 'kids',
            id: '176705',
            hasSpecialNavInteraction: true,
            espotIdentifier: '176705-ANF',
          },
          {
            label: 'Jeans',
            id: '130706',
            hasSpecialNavInteraction: false,
            espotIdentifier: '130706-ANF',
          },
        ]}
      />
      {/* Example of an L1+ regular menu */}
      <Menu
        clearanceLinks={[
          {
            label: 'Clearance',
            id: '12205',
            hasSpecialNavInteraction: false,
            espotIdentifier: '12266-ANF',
          },
        ]}
        espotIdentifier="12203-ANF"
        featuredLinks={[
          {
            label: 'Out & About',
            id: '619058645',
            link: '/shop/us/womens-out-and-about',
            hasSpecialNavInteraction: false,
            espotIdentifier: '12266-ANF',
          },
          {
            label: 'Bra Free Collection',
            id: '620072553',
            link: '/shop/us/womens-bra-free-collection',
            hasSpecialNavInteraction: false,
            espotIdentifier: '12266-ANF',
          },
          {
            label: 'A&F Essentials',
            id: '67155128',
            link: '/shop/us/womens-a-and-f-essentials-67155128',
            hasSpecialNavInteraction: false,
            espotIdentifier: '12266-ANF',
          },
        ]}
        handleClick={(id) => console.log(id)}
        heading="Women's"
        regularLinks={[
          {
            label: 'New Arrivals',
            id: '12266',
            hasSpecialNavInteraction: false,
            espotIdentifier: '12266-ANF',
          },
          {
            label: 'Dresses & Jumpsuits',
            id: '12265',
            hasSpecialNavInteraction: false,
            espotIdentifier: '12266-ANF',
          },
          {
            label: 'Tops',
            id: '6570723',
            hasSpecialNavInteraction: false,
            espotIdentifier: '12266-ANF',
          },
          {
            label: 'Bottoms',
            id: '6570724',
            hasSpecialNavInteraction: false,
            espotIdentifier: '12266-ANF',
          },
          {
            label: 'Coats & Jackets',
            id: '12252',
            hasSpecialNavInteraction: false,
            espotIdentifier: '12266-ANF',
          },
          {
            label: 'Kids',
            id: '176705',
            hasSpecialNavInteraction: true,
            espotIdentifier: '176705-ANF',
          },
        ]}
      />
    </>
  );
};

MenuDataWrapper.propTypes = {
  data: smallScreenNavDataV2Shape,
};

export default MenuDataWrapper;
